// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-cad8d534] .el-dialog__header {\n  display: block !important;\n  background: #FFFFFF;\n  padding: 14px 24px 0px;\n}\n[data-v-cad8d534] .el-dialog__body {\n  padding: 0px 20px 30px !important;\n}\nimg[data-v-cad8d534] {\n  width: 400px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
